module.exports = __webpack_public_path__ + "img/icon_arrow_left_white.3c6a36b8.svg";